// Independent page composition for Enterprise Application Architecture.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function EnterpriseArchitecturePage({ service }) {
  return h(PageFrame, { service, tone: 'editorial', hero: diagram(service, 'layers') },
    section('Architecture grounded in operations', split(context(service), scope())),
    section('What we can deliver', deliverables(service), { theme: 'ai-wash', eyebrow: 'From design to implementation' }),
    section(null, split(scenario(service), answer(service)))
  );
};
